import { useState } from "react";

export type LegendItem = {
  id: string;
  title: string;
  color: string;
  isActive: boolean;
};

export type LegendsReturnType = ReturnType<typeof useLegends>;

export const useLegends = (initialLegends: LegendItem[]) => {
  const [legends, setLegends] = useState<LegendItem[]>(initialLegends);

  const handleLegendItemClick = (legendId: string) => {
    const legend = legends.find((legend) => legend.id === legendId);
    if (!legend) return;
    setLegends((prev) =>
      prev.map((legend) =>
        legend.id === legendId ? { ...legend, isActive: !legend.isActive } : legend
      )
    );
  };

  return {
    legends,
    setLegends,
    handleLegendItemClick,
  };
};
